import React, { useCallback } from 'react';
import SourceProfilesViewPage from './SourceProfilesViewPage';
import { getTeamLeadSourceProfiles } from '../services/sourceProfileSearchService';

function TeamLeadProfilesViewPage() {
  const fetchProfiles = useCallback(
    ({ from, to } = {}) => getTeamLeadSourceProfiles({ from, to }),
    [],
  );

  return <SourceProfilesViewPage fetchProfiles={fetchProfiles} />;
}

export default TeamLeadProfilesViewPage;
